// extracted by mini-css-extract-plugin
module.exports = {"filtersList":"styles_filtersList__3XPP1","tag":"styles_tag__3sU5_","tagDelete":"styles_tagDelete__Mp3D5"};